import React from 'react';

const TypingIndicator = ({ username = "Someone" }) => {
  return (
    <div className="flex items-center gap-2 px-4 py-2 text-sm text-gray-600">
      <span className="font-medium">{username}</span>
      <span>is typing</span>
      <div className="flex gap-1">
        <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></span>
        <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></span>
        <span className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></span>
      </div>
    </div>
  );
};

export default TypingIndicator;
